/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DataFromJSON, DataToJSON, } from './Data';
/**
 * Check if a given object implements the RootCategoryResponseDTO interface.
 */
export function instanceOfRootCategoryResponseDTO(value) {
    return true;
}
export function RootCategoryResponseDTOFromJSON(json) {
    return RootCategoryResponseDTOFromJSONTyped(json, false);
}
export function RootCategoryResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'] == null ? undefined : DataFromJSON(json['data']),
    };
}
export function RootCategoryResponseDTOToJSON(json) {
    return RootCategoryResponseDTOToJSONTyped(json, false);
}
export function RootCategoryResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'data': DataToJSON(value['data']),
    };
}
